import { mapGetters } from 'vuex';
import { Notify } from 'quasar';

export default {
  computed: {
    ...mapGetters('user', ['label']),
    labelName() {
      return this.label ? this.label.translation : 'Aevitae';
    },
  },
  created() {
    document.addEventListener('swUpdated', this.showShouldRefreshNotification);
  },
  methods: {
    showShouldRefreshNotification() {
      Notify.create({
        type: 'warning',
        progress: true,
        message: this.$t('general.refresh-notification-message', { labelName: this.labelName }),
        position: 'top',
        multiline: true,
        actions: [
          {
            label: 'Ok',
            color: 'white',
            handler: () => {
              location.reload();
            },
          },
        ],
        timeout: 0,
      });
    },
  },
};
